import axios from "axios";

const instance= axios.create({
    // baseURL:"https://botpress-api.serviceschoolhouse.com"
    baseURL:"https://botpress-api.serviceschoolhouse.com"
})
export default instance